import { render, staticRenderFns } from "./PermissionName.vue?vue&type=template&id=93834598&"
import script from "./PermissionName.vue?vue&type=script&lang=ts&"
export * from "./PermissionName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports